import { getUserById } from "@/services/Login";
import { setUserContextIds } from "@/utils/sessionStorage";
import { User } from "@/types";

/** The registrant had no company before submitting, so the first role with a company is the new one. */
export const findRegisteredCompanyId = (user: Pick<User, "role"> | undefined) =>
  user?.role?.find((role) => !!role.companyId)?.companyId ?? null;

/**
 * Points the session at the company the submitted registration created and reloads, the same way changeCompany does,
 * so companies, roles and caches load fresh. Resolves false when the backend hasn't linked a role yet.
 */
export async function switchToRegisteredCompany(
  userId: number,
  navigate: (url: string) => void = (url) => window.location.assign(url)
): Promise<boolean> {
  const { data: user } = await getUserById(userId);
  const companyId = findRegisteredCompanyId(user);
  if (!companyId) return false;
  setUserContextIds({ userId, companyId });
  navigate("/dashboard");
  return true;
}
